import React from "react";
import { serviceData } from "../../fourthUtils/constant";
import allPaths from "../../Config/paths"
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const HomeService = (props) => {
    const { selectedLanguage, language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    const history = useHistory()
    return (
        <>
            <div className="frth-des-home-service-main">
                {
                    serviceData?.map((v, i) => {
                        return (
                            <div>
                                <button>{v?.icon}</button>
                                <p>
                                    {isELSelect ? v?.name : (isAlSelect ? v?.alName : v?.glName)}
                                </p>
                            </div>
                        )
                    })
                }
            </div>
            <div className="frth-des-btn">
                <button onClick={() => history?.push(allPaths?.FOURHTSERVICE)}>{selectedLanguage?.txt_view_services}</button>
            </div>
        </>
    )
}
export default HomeService